// extracted by mini-css-extract-plugin
module.exports = {"root":"Card_root__2B_87"};